import "./App.css";
import SmoothScroll from "./components/SmoothScroll";
import ScrollProgress from "./components/ScrollProgress";
import BackToTop from "./components/BackToTop";
import Navbar from "./components/Navbar";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Technology from "./components/sections/Technology";
import Pipeline from "./components/sections/Pipeline";
import Team from "./components/sections/Team";
import Contact from "./components/sections/Contact";

function App() {
  return (
    <SmoothScroll>
      <div className="App relative">
        <div className="grain" />
        <ScrollProgress />
        <BackToTop />
        <Navbar />
        <main>
          <Hero />
          <About />
          <Technology />
          <Pipeline />
          <Team />
          <Contact />
        </main>
      </div>
    </SmoothScroll>
  );
}

export default App;
